import AddressFindEnumDTO from "features/shared/enums/dynamic/AddressFindEnumDTO";
import { FormValidations } from "features/shared/forms/hooks/useForm";
import { Nullable } from "features/shared/types/nullable";

export const addressFormValidations = (): FormValidations => {
  return {
    Address: {
      required: true,
      type: "OnlyRequired"
    }
  };
}